/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Dynamic item base class used for creating dynamic components
 * @access private
 */

import { Type } from '@angular/core';

export class DynamicItem<T> {
  public component: NgAemComponent;
  public data: T;

  constructor(component: NgAemComponent, data: T) {
    this.component = component;
    this.data = data;
  }
}

export type NgAemComponent = Type<Object>;
